var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.001 5.00001C14.001 5.13262 13.9483 5.25979 13.8545 5.35356C13.7608 5.44733 13.6336 5.50001 13.501 5.50001L1.70798 5.50001L4.85498 8.64601C4.94886 8.7399 5.00161 8.86723 5.00161 9.00001C5.00161 9.13278 4.94886 9.26012 4.85498 9.35401C4.76109 9.4479 4.63375 9.50064 4.50098 9.50064C4.3682 9.50064 4.24086 9.4479 4.14698 9.35401L0.146977 5.35401C0.100414 5.30756 0.0634712 5.25239 0.0382647 5.19164C0.0130581 5.1309 8.33574e-05 5.06578 8.33631e-05 5.00001C8.33689e-05 4.93424 0.0130581 4.86912 0.0382647 4.80838C0.0634713 4.74763 0.100414 4.69245 0.146977 4.64601L4.14698 0.646009C4.24086 0.552122 4.3682 0.499377 4.50098 0.499377C4.63375 0.499377 4.76109 0.552122 4.85498 0.646009C4.94886 0.739895 5.00161 0.867233 5.00161 1.00001C5.00161 1.13278 4.94886 1.26012 4.85498 1.35401L1.70798 4.50001L13.501 4.50001C13.6336 4.50001 13.7608 4.55269 13.8545 4.64646C13.9483 4.74022 14.001 4.8674 14.001 5.00001Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/ArrowBack.6338731c7aaac83b8a6df350eec1ec1e.svg";
export { ForwardRef as ReactComponent };